import Typography from "@mui/material/Typography";
import type { SearchTemplateValue } from "../../api/";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { setClassNamesByCount } from "./utils";

export const ExpiredReminders = ({
	expiredRemindersCorona,
	readOnly = false,
}: {
	expiredRemindersCorona: SearchTemplateValue;
	readOnly?: boolean;
}) => {
	return (
		<BaseTodoBox
			className={setClassNamesByCount(expiredRemindersCorona.count)}
			title={
				<AttentionBadge
					count={expiredRemindersCorona.count}
					title="Expired Reminders"
					readOnly={readOnly}
					url={expiredRemindersCorona.url}
				/>
			}
			description={
				<>
					<Typography variant="body1" color="textPrimary">
						Remove or postpone reminder
					</Typography>
				</>
			}
		/>
	);
};
